const ProductPage = {
    selectors: {
        "parent": { selector: "#product-swatches", type: "single", scope: "document" },
        "qsBtn": { selector: "#questions-btn", type: "single", scope: "document" },
        "reviewsBtn": { selector: "#reviews-btn", type: "single", scope: "document" },
        "reviewsDiv": { selector: "#reviews-div", type: "single", scope: "document" },
        "qsDiv": { selector: "#questions-div", type: "single", scope: "document" },
        "reviewsLink": { selector: "#reviews-link", type: "single", scope: "document" },
        "reviewsSection": { selector: "#reviews-section", type: "single", scope: "document" },
        "addToCartBtn": { selector: ".add-to-cart-main", type: "single", scope: "document" },
        "warrantyLinks": { selector: ".warranty-icon, .warranty-text", type: "all", scope: "document" },
        "warrantyAccordion": { selector: ".warranty-accordion", type: "single", scope: "document" },
        "sizeChartBtn": { selector: "#size-chart-btn", type: "single", scope: "document" },
        "sizeChart": { selector: "#size-chart-modal", type: "single", scope: "document" },
        "shapeTabs": { selector: '.shape-tab', type: "all", scope: "document" },
        "shapeGuideBtn": { selector: "#shape-guide-btn", type: "single", scope: "document" },
        "shapeGuide": { selector: "#shape-guide-modal", type: "single", scope: "document" },
        "idInput": { selector: ".product-id-input", type: "single", scope: "parent" },
        "pricesMain": { selector: ".prices-main", type: "all", scope: "document" },
        "resourcesHeader": { selector: ".resources-header", type: "single", scope: "document" },
        "ymalHeader": { selector: ".ymal-header", type: "single", scope: "document" },
        "fbtProductCards": { selector: ".fbt-product-card", type: "all", scope: "document" },
        "minusBtns": { selector: ".minus", type: "all", scope: "parent" },
        "plusBtns": { selector: ".plus", type: "all", scope: "parent" },
        "thumbnails": { selector: ".thumbnails-inner", type: "single", scope: "document" },
        "selected":  { selector: ".selected-outer", type: "single", scope: "document" },
        "thumbnailImages": { selector: ".thumbnail", type: "all", scope: "document" },
        "allSwatches": { selector: ".swatch-btn", type: "all", scope: "parent" },
        "ogTitleWithShape": { selector: 'meta[property="og:title"]', type: "single", scope: "document" },
        "ogImage": { selector: 'meta[property="og:image"]', type: "single", scope: "document" },
        "ogImageSecureUrl": { selector: 'meta[property="og:image:secure_url"]', type: "single", scope: "document" },
        "closeBtns": { selector: ".pdp-modal .icon-close", type: "all", scope: "document" },
        "videoThumbs": { selector: ".video-thumbnail", type: "all", scope: "document" },
        "pdpAccordions": { selector: ".accordion-container", type: "all", scope: "document" },
        "clothingDescH3": { selector: ".clothing-details-content h3", type: "single", scope: "document" },
        "fixedAddToCartBtn": {selector: "#fixed-add-to-cart-container", type: 'single', scope: "document"},
        "announcementBar": { selector: ".announcement-bg", type: "single", scope: "document" },
        "mainContainer": {selector: ".product-page-template", type: 'single', scope: "document"},
        "notifyBtn": {selector: "#notify-me-pdp", type: "single", scope: "document"},
        "notifyForm": {selector: "#notify-me-form-container", type: "single", scope: "document"},
        "notifyMeSubmit": {selector: ".notify-me-submit", type: "all", scope: "document"},
        "optSelectedCustom": { selector: ".customization-modal .option-selected", type: "single", scope: "document" },
        "swatchesCustom": { selector: ".swatch-btn-customization", type: "all", scope: "document" },
        "customizationModal": { selector: ".customization-modal", type: "single", scope: "document" },
        "customizeBtn": { selector: ".customize-btn", type: "single", scope: "document" },
        "modelInfo": { selector: ".model-info", type: "all", scope: "document" },
        "gripInput": { selector: "#custom-grip-input", type: "single", scope: "document" },
        "gripSelect" : { selector: "#grip_type_select", type: "single", scope: "document" },
        "customOptsBtns": { selector: ".swatch-btn-customization", type: "all", scope: "document" },
        "gripOptionsContainer": { selector: ".custom-grip-opts", type: "single", scope: "document" },
    },

    init: async function(handle, variantId, productType, retired, stockAlert, templateSuffix, tease) {
        // Register before any awaits so the listener is always in place before load fires
        if (document.readyState === 'complete') {
            this.initStatBars();
        } else {
            window.addEventListener('load', () => {
                this.initStatBars();
            });
        }

        this.hasFunctionalityConsent = false;
        this.lastClickedVideo = null;
        this.productType = productType;
        this.retired = retired;
        this.stockAlert = stockAlert;
        Utility.fetchEls(this.selectors, this);
        this.childIds = await Utility.fetchChildIds(handle);
        this.productData = await Utility.fetchProductDataAjax(handle, productType, this.childIds);
        this.productDetails = await Utility.fetchProductDetails(handle, variantId);
        const { productData } = this;
        this.templateSuffix = templateSuffix;
        this.tease = tease == 'true' ? true : false;
      
        const shapeSwatch = document.querySelector('.swatch-btn-shape.selected');
        if (shapeSwatch) {
          this.selectedShape = shapeSwatch.dataset.swatchValue;
        }
      
        await this.initUrl(variantId);
        this.initCarouselScrolling();
        this.modalBg = Shared.modalBg;
        if (!retired && productData) {
          Shared.handleOutOfStock(false, variantId);
          if (productData.variants.length !== 1 && !this.tease) {
            Shared.initSwatchesStock(productData);
            this.initCustomizations();
          }
        }
        
        const { fbtProductCards } = this;
        if (fbtProductCards.length) {
           fbtProductCards.forEach((card) => {
            const firstSwatch = card.querySelector('.selected');
            if (firstSwatch) {
              Shared.handleSwatchChange(firstSwatch, false, true);
            }
          });
        }
         
        this.initEventListeners();
        if (productData && productData.title.includes('Pro Air')) {
            this.ampedProAirInit();
        }

        if (productType == 'Apparel' && window.innerWidth < 1200 && this.clothingDescH3) {
          const textBlock = this.clothingDescH3.closest('.text-block');
          textBlock.parentNode.insertBefore(this.clothingDescH3, textBlock);
        }

      if (window.innerWidth < 1200) {
        const desktopH1 = document.querySelector('h1.desktop');
        if (desktopH1) {
          desktopH1.remove();
        }
      } else {
        const mobileH1 = document.querySelector('h1.mobile');
        if (mobileH1) {
          mobileH1.remove();
        }
      }

      if ('IntersectionObserver' in window) {
        this.setupIntersectionObserver();
      } else {
        // Fallback for older browsers
        this.toggleFixedATC = this.toggleFixedATC.bind(this);
        document.addEventListener('scroll', this.toggleFixedATC, { passive: true });
        window.addEventListener('resize', this.toggleFixedATC);
        this.toggleFixedATC(); // Initial check
      }

    },
    
    initEventListeners: function() {
        const {
            addToCartBtn,
            fixedAddToCartBtn,
            warrantyLinks,
            warrantyAccordion,
            allSwatches,
            sizeChartBtn,
            sizeChart,
            modalBg,
            shapeGuideBtn,
            shapeTabs,
            shapeGuide,
            closeBtns,
            videoThumbs,
            pdpAccordions,
            productType,
            notifyBtn,
            notifyForm,
            notifyMeSubmit
        } = this;

        // add to cart initial state and event listeners
        if (addToCartBtn) {
          addToCartBtn.disabled = false;
        }
        if (fixedAddToCartBtn) {
          fixedAddToCartBtn.disabled = false;
        }

        // Attach event to both buttons
        const buttons = [addToCartBtn, fixedAddToCartBtn];
        buttons.forEach((btn) => {
          if (btn) {
            btn.addEventListener('click', (event) => {
              Cart.addToCart(event);
            });
          }
        });
 
        notifyMeSubmit.forEach((btn) => {
          btn.addEventListener('click', function() {
            const productId = btn.dataset.productId;
            const source = btn.dataset.source || 'backInStockPdp';
            const formType = btn.dataset.formType;
        
            let message = '';
            if (formType === 'notify') {
              message = `Don't miss the drop! Enter your email to be notified when the ${btn.dataset.productTitle} restock. Subscribers get first access before the public release.`;
            } else if (formType === 'backInStock') {
              message = `Enter your email to be notified when ${btn.dataset.productTitle} is back in stock.`;
            } else if (formType === 'signUp') {
              message = `This limited-edition color went fast during presale! Don't miss out on the next special drop — sign up for email now to be the first to know.`;
            }
        
            notifyForm.setAttribute('data-product-id', productId);
            notifyForm.setAttribute('data-source', source);
            notifyForm.setAttribute('data-form-type', formType);
            notifyForm.querySelector('#notify-me-text').textContent = message;
        
            modalBg.style.display = 'block';
            notifyForm.style.display = 'flex';
          });
        });
        
        // scroll to warranty section on click
        if (warrantyLinks) {
          warrantyLinks.forEach((link) => {
            link.addEventListener('click', function() {
              warrantyAccordion.scrollIntoView({ behavior: 'smooth' });
              // add this function into this script?
              togglefaqAccordion(4);
            });
          });
        }

        if (allSwatches.length) {
          // handle swatch change when swatch clicked
          allSwatches.forEach((swatch) => {
              swatch.addEventListener('click', () => {
                  Shared.handleSwatchChange(swatch);
              });
          });
        }

        this.initReviewsQsEventListeners();
        Shared.initQuantityEventListeners();
        
        if (sizeChartBtn) {
            sizeChartBtn.addEventListener('click', function() {
                modalBg.style.display = 'block';
                sizeChart.style.display = 'block';
            });
        }

        if (shapeGuideBtn) {
          if (window.innerWidth < 769) {
            this.updateShapeGuide();
          }
          window.addEventListener('resize', () => {
            if (window.innerWidth < 769) {
              this.updateShapeGuide();
            }
          });
          shapeGuideBtn.addEventListener('click', function() {
              if (shapeGuideBtn.closest('.product-page-template')) {
                modalBg.style.display = 'block';
                shapeGuide.style.visibility = 'visible';
              }
          });
        }

        this.initTechSpecsScroll();

        if (closeBtns) {
            closeBtns.forEach((btn) => {
              btn.addEventListener('click', function(){
                  const modal = btn.closest('.pdp-modal');
                  if (modal.id == 'shape-guide-modal') {
                    modal.style.visibility = 'hidden';
                  } else {
                    modal.style.display = 'none';
                  }
                  if (!btn.classList.contains('grip-guide-close')) {
                    modalBg.style.display = 'none';
                  }
              });
            });
          }

        if (videoThumbs) {
          const innerHTML = `
            <img src="https://img.youtube.com/vi/<video_id>/hqdefault.jpg" loading="lazy" alt="Video Thumbnail">
            <div class="play-button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path fill="#d00b2b" d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"/></svg></div>
          `;
          Utility.initVideoThumbs(videoThumbs, innerHTML);
        }
          

      if (pdpAccordions) {
        pdpAccordions.forEach((dropdown) => {
          dropdown.addEventListener('click', () => {
            const isExpanded = dropdown.classList.contains('expanded');
            pdpAccordions.forEach((other) => {
              other.classList.remove('expanded');
            });
            if (!isExpanded) {
              dropdown.classList.add('expanded');
              dropdown.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          });
        });
      }
  },
  
    updateShapeGuide: function() {
        const {selectedShape, shapeTabs} = this;
        shapeTabs.forEach((tab) => {
          if (tab.dataset.shape == selectedShape) {
            tab.classList.add('active');
          } else {
            tab.classList.remove('active');
          }
        });
      },

    // Updates stat bar indicators and numeric values in .pdp-stat-bars for the given variant.
    // Values are on a 0-10 scale and are multiplied by 10 to produce the 0-100 CSS percentage.
    // Animates via GSAP when available, otherwise falls back to a direct style set.
    // Hides individual rows when a stat is absent and hides the entire section if no stats exist.
    updateStatBars: function(variantData) {
        const section = document.querySelector('.pdp-stat-bars');
        if (!section) { return; }

        const statMap = {
          'spin': variantData.spin,
          'control': variantData.control,
          'power': variantData.power,
          'sweet-spot': variantData.sweetspot
        };

        let anyVisible = false;

        Object.entries(statMap).forEach(([stat, rawValue]) => {
          const row = section.querySelector(`.pdp-stat-bar-row[data-stat="${stat}"]`);
          if (!row) { return; }

          if (rawValue === null || rawValue === undefined || rawValue === '') {
            row.style.display = 'none';
            return;
          }

          row.style.display = '';
          anyVisible = true;

          const rounded = Math.round(parseFloat(rawValue));
          const targetPercent = rounded * 10;
          const indicator = row.querySelector('.pdp-stat-bar-indicator');
          const valueEl = row.querySelector('.pdp-stat-bar-value');

          if (indicator) {
            indicator.dataset.value = targetPercent;

            if (typeof gsap !== 'undefined') {
              const currentPos = parseFloat(indicator.style.getPropertyValue('--stat-pos')) || 0;
              const proxy = { pos: currentPos };
              gsap.to(proxy, {
                pos: targetPercent,
                duration: 0.6,
                ease: 'power2.out',
                onUpdate: function() {
                  indicator.style.setProperty('--stat-pos', proxy.pos);
                  if (valueEl) {
                    valueEl.textContent = Math.round(proxy.pos / 10);
                  }
                },
                onComplete: function() {
                  indicator.style.setProperty('--stat-pos', targetPercent);
                  if (valueEl) {
                    valueEl.textContent = rounded;
                  }
                }
              });
            } else {
              indicator.style.setProperty('--stat-pos', targetPercent);
              if (valueEl) {
                valueEl.textContent = rounded;
              }
            }
          }
        });

        section.style.display = anyVisible ? '' : 'none';
      },

    // Runs once on page load. Animates bars from 0 to their server-rendered values
    // using a ScrollTrigger timeline so the animation fires when the section enters the viewport.
    initStatBars: function() {
        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') { return; }

        gsap.registerPlugin(ScrollTrigger);

        const section = document.querySelector('.pdp-stat-bars');
        if (!section || section.style.display === 'none') { return; }

        const visibleRows = Array.from(
            section.querySelectorAll('.pdp-stat-bar-row')
        ).filter((row) => row.style.display !== 'none');

        visibleRows.forEach((row) => {
            const indicator = row.querySelector('.pdp-stat-bar-indicator');
            const valueEl = row.querySelector('.pdp-stat-bar-value');
            if (indicator) {
                indicator.style.setProperty('--stat-pos', 0);
            }
            if (valueEl) {
                valueEl.textContent = '0';
            }
        });

        const statTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: 'top 82%',
                once: true
            }
        });

        visibleRows.forEach((row, index) => {
            const indicator = row.querySelector('.pdp-stat-bar-indicator');
            const valueEl = row.querySelector('.pdp-stat-bar-value');
            if (!indicator) { return; }

            const targetValue = parseFloat(indicator.dataset.value || 0);
            const proxy = { pos: 0 };

            statTimeline.to(proxy, {
                pos: targetValue,
                duration: 0.9,
                ease: 'power2.out',
                onUpdate: function() {
                    indicator.style.setProperty('--stat-pos', proxy.pos);
                    if (valueEl) {
                        valueEl.textContent = Math.round(proxy.pos / 10);
                    }
                },
                onComplete: function() {
                    indicator.style.setProperty('--stat-pos', targetValue);
                    if (valueEl) {
                        valueEl.textContent = Math.round(targetValue / 10);
                    }
                }
            }, index * 0.14);
        });
    },

    initReviewsQsEventListeners: function() {
        const {reviewsLink, reviewsBtn, qsBtn, reviewsDiv, qsDiv, reviewsSection} = this;
        // reviews/qs event listeners
        if (reviewsLink) {
          reviewsLink.addEventListener('click', function() {    
            reviewsSection.scrollIntoView({ behavior: 'smooth' });
          });
        }

        if (reviewsBtn) {
          reviewsBtn.addEventListener('click', function() {
            reviewsDiv.style.display = 'block';
            qsDiv.style.display = 'none';
            reviewsBtn.classList.add('active-btn');
            qsBtn.classList.remove('active-btn');
          });
        }
        
        if (qsBtn) {
          qsBtn.addEventListener('click', function() {
            reviewsDiv.style.display = 'none';
            qsDiv.style.display = 'block';
            qsBtn.classList.add('active-btn');
            reviewsBtn.classList.remove('active-btn');
          });
        }
        
    },
    
    getVariantFromUrl: function() {
        const { productData } = this;
        if (!productData || !productData.variants) {
            return null;
        }
        const url = new URL(window.location.href);
        const urlParams = new URLSearchParams(url.search);
        const variantId = urlParams.get('variant');
        const variants = productData.variants;
        const isVariant = variants.find((variant) => variant.id == variantId);
        return isVariant;
    },
    
    initUrl: function(variantId) {
        const { productData } = this;
        const variant = this.getVariantFromUrl(productData);
        const url = new URL(window.location.href);
        if (variant && variant.title.includes('Custom')) {
            let variantTitle = variant.title.split(' / ');
            variantTitle = variantTitle.filter((part) => !part.includes('Custom'));
            const matchedVariant = productData.variants.find((productVariant) => {
                let productVariantTitleParts = productVariant.title.split(' / ');
                // Check if every part of variantTitle is included in productVariantTitleParts
                // and that 'Custom' is not included
                return variantTitle.every((part) => productVariantTitleParts.includes(part)) &&
                    !productVariantTitleParts.some((part) => part.includes('Custom'));
            });
            url.searchParams.set('variant', matchedVariant.id);
            window.history.pushState({ path: url.toString() }, '', url.toString());
        }
        else if (!variant) {
            url.searchParams.set('variant', variantId);
            window.history.pushState({ path: url.toString() }, '', url.toString());
        }
    },

    initTechSpecsScroll: function() {
      const container = document.querySelector('#features-content');
      let scrollDistance = 400;
      const scrollDuration = 300;
        if (window.innerWidth < 476) {
          scrollDistance = 200;
        } else if (window.innerWidth < 571 && window.innerWidth > 475) {
          scrollDistance = 250;
        }

      const leftArrow = document.querySelector('.features-container .left-arrow');
      if (leftArrow) {
        leftArrow.addEventListener('click', () => {
          Utility.smoothScroll(container, -scrollDistance, scrollDuration);
        });
      }
      
      const rightArrow = document.querySelector('.features-container .right-arrow');
      if (rightArrow) {
        rightArrow.addEventListener('click', () => {
          Utility.smoothScroll(container, scrollDistance, scrollDuration);
        });
      }
    },
    
    initCarouselScrolling: function() {
        const {resourcesHeader, ymalHeader} = this;
        let scrollDistance = 375;
        const scrollDuration = 300;
        if (window.innerWidth < 476) {
            scrollDistance = 150;
        } else if (window.innerWidth < 571 && window.innerWidth > 475) {
            scrollDistance = 200;
        }
        if (resourcesHeader) {
            const resourcesContainer = document.querySelector('.resources-carousel');
            const resourcesArrows = resourcesHeader.querySelectorAll('.navigation-arrow');
            resourcesArrows.forEach((arrow) => {
                arrow.addEventListener('click', () => {
                const direction = arrow.id;
                if (direction.includes('left')) {
                    Utility.smoothScroll(resourcesContainer, -scrollDistance, scrollDuration);
                } else if (direction.includes('right')) {
                    Utility.smoothScroll(resourcesContainer, scrollDistance, scrollDuration);
                }
                });
            });
        }
        
        if (ymalHeader) {
            const ymalContainer = document.querySelector('.ymal-products');
            const ymalArrows = ymalHeader.querySelectorAll('.navigation-arrow');
            
            const wrapScroll = (target) => {
                const start = ymalContainer.scrollLeft;
                const end = Math.max(0, Math.min(target, ymalContainer.scrollWidth - ymalContainer.clientWidth));
                const startTime = performance.now();
                const snap = ymalContainer.style.scrollSnapType;
                const behavior = ymalContainer.style.scrollBehavior;
                
                ymalContainer.style.scrollSnapType = 'none';
                ymalContainer.style.scrollBehavior = 'auto';

                (function step(now) {
                    const progress = Math.min((now - startTime) / 150, 1);
                    ymalContainer.scrollLeft = start + (end - start) * progress;
                    if (progress < 1) {
                        requestAnimationFrame(step);
                    } else {
                        ymalContainer.style.scrollSnapType = snap;
                        ymalContainer.style.scrollBehavior = behavior;
                    }
                })(startTime);
            };
            
            ymalArrows.forEach((arrow) => {
                arrow.addEventListener('click', () => {
                    const firstCard = ymalContainer.querySelector('.ymal-product-card');
                    const containerStyle = window.getComputedStyle(ymalContainer);
                    const gap = parseFloat(containerStyle.columnGap) || 0;
                    const cardWidth = firstCard ? firstCard.offsetWidth + gap : 300;
                    const maxScrollLeft = ymalContainer.scrollWidth - ymalContainer.clientWidth;
                    const currentScroll = ymalContainer.scrollLeft;
                    const direction = arrow.dataset.direction || arrow.id;
                    
                    if (direction.includes('left')) {
                        if (currentScroll <= cardWidth / 2) {
                            wrapScroll(maxScrollLeft);
                        } else {
                            Utility.smoothScroll(ymalContainer, -cardWidth, 0);
                        }
                    } else if (direction.includes('right')) {
                        if (currentScroll >= maxScrollLeft - cardWidth / 2) {
                            wrapScroll(0);
                        } else {
                            Utility.smoothScroll(ymalContainer, cardWidth, 0);
                        }
                    }
                });
            });
        }
    },
    
    ampedProAirInit: function() {
      const { addToCartBtn, productData, fixedAddToCartBtn, announcementBar } = this;
      const parent = document.querySelector('.product-page-template');
      if (!parent) {
        return;
      }
      const selectedSwatch = parent.querySelector('.swatch-btn.selected');
      if (!selectedSwatch) {
        return;
      }
      const swatchValue = selectedSwatch.dataset.swatchValue;
      if (announcementBar) {
        announcementBar.style.backgroundColor = selectedSwatch.dataset.bgColor;
      }
      // Apply color to both add to cart buttons
      if (addToCartBtn) {
        addToCartBtn.style.backgroundColor = selectedSwatch.dataset.bgColor;
      }
      if (fixedAddToCartBtn) {
        fixedAddToCartBtn.style.backgroundColor = selectedSwatch.dataset.bgColor;
      }
      const fbtProducts = document.querySelectorAll('.fbt-product-card');
      if (!fbtProducts.length) {
        return;
      }
      fbtProducts.forEach((product) => {
        const swatches = product.querySelectorAll('.swatch-fbt');
        let swatchToSelect = null;
        Array.from(swatches).forEach((swatch) => {
            if (swatch.dataset.swatchValue.includes(swatchValue)) {
                swatchToSelect = swatch;
            } else if (swatchValue == 'Gray') {
              if (swatch.dataset.swatchValue.includes('Black')) {
                swatchToSelect = swatch;
              }
            }
        });
        if (swatchToSelect) {
          swatchToSelect.click();
        }
      });
    },

    // Sets up an IntersectionObserver to monitor visibility of the main Add to Cart button.
    // When the button scrolls out of view, it shows the fixed (sticky) Add to Cart button.
    setupIntersectionObserver: function () {
      if (!this.addToCartBtn || !this.fixedAddToCartBtn) return;
    
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting && this.addToCartBtn.offsetParent !== null) {
            this.fixedAddToCartBtn.classList.add('active');
          } else {
            this.fixedAddToCartBtn.classList.remove('active');
          }
        });
      }, {
        root: null, // viewport
        threshold: 0.1 // Trigger when 10% of button is visible
      });
    
      observer.observe(this.addToCartBtn);
    },  

    // Fallback method for browsers that don't support IntersectionObserver.
    // It manually checks if the main Add to Cart button is visible in the viewport.
    toggleFixedATC: function() {
      if (!this.addToCartBtn) return;
      const rect = this.addToCartBtn.getBoundingClientRect();
      const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

      if (!isVisible && this.addToCartBtn.offsetParent !== null) {
        this.fixedAddToCartBtn.classList.add('active');
      } else {
        this.fixedAddToCartBtn.classList.remove('active');
      }
    },
    initCustomizations: function(modal = false) {
        const { gripSelect, gripGuideBtn, gripGuide, customizationModal, customizeBtn, modalBg, customOptsBtns } = this;
        const productData = this.productData;
        const productDetails = this.productDetails;
        const mainContainer = this.mainContainer;
        const customParent = customizationModal;

        //Check if it's a customizable product:
        const canCustomize = !!customizeBtn;
        
        if (canCustomize) {
          customizeBtn.addEventListener('click', () => {
              customizationModal.style.display = 'block';
              modalBg.style.display = 'block';
          });
          if (gripGuideBtn) {
            gripGuideBtn.addEventListener('click', function() {
                gripGuide.style.display = 'block';
            });
          }
          this.saveBtn = customParent.querySelector('.save-btn');
          this.selectedCustoms = document.querySelector('.selected-custom');
          this.gripError = customParent.querySelector('.grip-error');

          this.saveBtn.addEventListener('click', () => {
              this.handleSaveCustomizations(modal);
          });
        }
        customOptsBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
              const swatchValue = btn.dataset.swatchValue;
              this.showCustomOptionsPDP(swatchValue);
              customOptsBtns.forEach((button) => button.classList.remove('selected'));
              btn.classList.add('selected');
          });
        });

        if (mainContainer && customizationModal) {
            mainContainer.appendChild(customizationModal);
        }
        
    },
    
    handleSaveCustomizations: function(modal) {
        const {gripSelect, saveBtn, selectedCustoms, modalBg, gripError, gripInput } = this;
        let optionsSelected = true;
        let parent; 
        if (modal) {
          parent = Modal.parent;
        } else {
          parent = ProductPage.parent;
        }
      
        if (gripSelect.required && !gripSelect.value) {
            optionsSelected = false;
            if (gripError) {
                gripError.style.display = 'block';
            }
        }
        
        selectedCustoms.textContent = '';
        
      if (optionsSelected) {
        if (selectedCustoms && gripSelect.value) {
          const grip = gripSelect.value;
          selectedCustoms.textContent = 'Selected Custom Grip: ' + grip.replace(' (BTOG)', '');
          // Store the selected grip value in the hidden input
          gripInput.value = grip;
          // Add the name so it will be included in the form submission
          gripInput.setAttribute('name', 'properties[Custom Grip]');
        } else {
          // No grip selected, clear the hidden input and exclude it from submission
          gripInput.value = '';
          gripInput.removeAttribute('name');
        }

        if (!modal) {
          modalBg.style.display = 'none';
        }
        saveBtn.closest('.pdp-modal').style.display = 'none';
      }
    },
    
    showCustomOptionsPDP: function (swatchValue) {
      const { gripSelect, gripGuideBtn, gripOptionsContainer, gripInput } = this;

      if (swatchValue.includes('grip')) {
        if (gripSelect) {
          gripSelect.required = true;
          gripOptionsContainer.style.display = 'block';
        }
        if (gripGuideBtn) {
          this.populateGripGuide(gripGuideBtn);
        }
      } else if (swatchValue == 'none') {
        if (gripSelect) {
          gripSelect.value = '';
          gripOptionsContainer.style.display = 'none';
          gripSelect.required = false;
        }
        // clear and prevent submission
        gripInput.value = '';
        gripInput.removeAttribute('name');

        if (gripGuideBtn) {
          gripGuideBtn.style.display = 'none';
        }
      }
    },
    
    populateGripGuide: function(gripGuideBtn) {
        const { gripSelect } = this;
        const gripDetails = document.querySelectorAll('.grip-details');
        const selectOptions = Array.from(gripSelect.options);
        const availableGrips = selectOptions.map((option) => option.value);
        gripDetails.forEach((grip) => {
        const foundGrip = availableGrips.find((opt) => opt.includes(grip.dataset.grip));
        if (foundGrip) {
            grip.style.display = 'block';
        }
        });
        gripGuideBtn.style.display = 'block';
    }
};